import React, { useEffect, useMemo, useState } from "react";
import { Icon } from "semantic-ui-react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCurrentToken } from "../auth/authSlice";
import SupportFeedbackModal from "./SupportFeedbackModal";
import styles from "./SupportFeedbackButton.module.css";

const NO_FEEDBACK_BUTTON_PATHS = ["/login", "/onboarding", "/pending-approval"];

const SupportFeedbackButton = () => {
  const token = useSelector(selectCurrentToken);
  const location = useLocation();
  const [open, setOpen] = useState(false);
  // Phones: the wide pill sat on top of card buttons, chart edges and last lines on every
  // page. There it is a small round icon that slides away while scrolling down and comes
  // back on the way up (CSS: .button under max-width 768px).
  const [tucked, setTucked] = useState(false);
  useEffect(() => {
    let lastY = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      if (y > lastY + 8 && y > 80) setTucked(true);
      else if (y < lastY - 8) setTucked(false);
      lastY = y;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const visible = useMemo(
    () => token && !NO_FEEDBACK_BUTTON_PATHS.includes(location.pathname),
    [token, location.pathname]
  );

  if (!visible) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        aria-label="피드백 보내기"
        className={`${styles.button} ${tucked ? styles.tucked : ""}`}
        onClick={() => setOpen(true)}
      >
        <Icon name="comment alternate" className={styles.icon} />
        <span className={styles.label}>피드백 보내기</span>
      </button>
      <SupportFeedbackModal open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default SupportFeedbackButton;
